import { createModule } from "saga-slice";
import { call, put } from "redux-saga/effects";
import { createPurchase, fetchNewOrderNumber, generateDocument, generatePurchaseReport, getPurchasesData, getTotalPurchasesForDateRange, getTotalPurchasesThisMonth, getTotalPurchasesThisWeek, getTotalPurchasesThisYear, getTotalPurchasesToday, search, updatePurchase, validerBC } from "../services/purchaseService";
import { set } from "lodash";

const purchaseModule = createModule({
  name: "purchases",
  initialState: {
    isLoading: false,
    error: null,
    currentPurchase: null,
    cart: [],
    purchases: [],
    totalPurchases: 0,
    totalAmountTtc: 0,
    totalAmountHt: 0,// Add this field
    grossRevenue: 0,
    netIncome: 0,
    currentPurchase: null,
    newOrderNumber: null,
    dateFrom: null,
    dateTo: null,
    supplierReportLoading: false,
    supplierReportError: null,
    supplierReport: null,
    lowStockItems: [],
    totalAmountHt: 0,
    totalElements: 0, // Total number of records
    totalPages: 0, // Total number of pages
    pageNumber: 0, // Current page number
    pageSize: 10, // Size of each page
  },
  selectors: {
    getCart: state => state.purchases?.cart || [],
    getTotalAmountHt: state => state.purchases?.totalAmountHt || 0,
    getIsLoading: state => state.purchases?.isLoading || false
  },
  reducers: {
    search: (state) => {
      state.isLoading = true;
    },
    fetchNewOrderNumber: (state) => {
      state.isLoading = true;
    },
    fetchPurchaseById: (state) => {
      state.isLoading = true;
    },
    createPurchase: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    generatePdfRequest: (state) => {
      state.isLoading = true;
    },
    getPurchasesData: (state) => {
      state.isLoading = true;
    },
    getPurchasesDataSuccess: (state, action) => {
      state.isLoading = false;
      state.totalPurchases = action.totalPurchases;
      state.grossRevenue = action.grossRevenue;
      state.netIncome = action.netIncome;
      state.lowStockItems = action.lowStockItems;
    },
    updatePurchase: (state, action) => {
      state.isLoading = false;
    },
    getPurchasesDataFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    finishFetching: (state) => {
      state.isLoading = false;
    },
    fetchedData: (state, payload) => {
      state.isLoading = false;
      state.purchases = payload.body;
    },
    getTotalPurchasesToday: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getTotalPurchasesThisWeek: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getTotalPurchasesThisMonth: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    getTotalPurchasesThisYear: (state, action) => {
      state.isLoading = true;
      state.error = null;
    },
    createPurchaseSuccess: (state) => {
      state.isLoading = false;
      state.cart = [];
      state.totalAmountHt = 0;
    },
    generateClientReport: (state) => {
      state.supplierReportLoading = true;
      state.supplierReportError = null;
    },
    createPurchaseFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    generatePdfSuccess: (state) => {
      state.isLoading = false;
    },
    generatePdfFailure: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    search: (state) => {
      state.isLoading = true;
    },
    generateDocument: (state) => {
      state.isLoading = true;
    },

    addToCart: (state, action) => {
      const existingItem = state.cart.find(item => item.id === action.id);
      if (existingItem) {
        existingItem.quantity += 1;
      } else {
        state.cart.push({ ...action, quantity: 1 });
      }
      state.totalAmountHt = state.cart.reduce((total, item) =>
        total + (item.buyingPrice * item.quantity), 0);
    },
    setTotalPurchase: (state, action) => {
      state.totalPurchases = action.payload;
    },
    clearCurrentPurchase: (state) => {
      state.currentPurchase = null;
    },
    removeFromCart: (state, action) => {
      state.cart = state.cart.filter(item => item.id !== action);
      state.totalAmountHt = state.cart.reduce((total, item) =>
        total + (item.buyingPrice * item.quantity), 0);
    },
    setPurchase: (state, action) => {
      state.isLoading = false;
      state.currentPurchase = action;
    },
    updateQuantity: (state, action) => {
      const item = state.cart.find(item => item.id === action.id);
      if (item) {
        item.quantity = action.quantity;
        state.totalAmountHt = state.cart.reduce((total, item) =>
          total + (item.buyingPrice * item.quantity), 0);
      }
    },
    validerBC: (state, action) => {
      state.isLoading = true;
    },
    setNewOrderNumber: (state, action) => {
      state.newOrderNumber = action;
      state.isLoading = false;
    },
    clearCart: (state) => {
      state.cart = [];
      state.totalAmountHt = 0;
    },
    generatePdfSuccess: (state) => {
      state.isLoading = false;
    },
    setError: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
    generateSupplierReport: (state) => {
      state.supplierReportLoading = true;
      state.supplierReportError = null;
    },
    generateSupplierReportSuccess: (state, action) => {
      state.supplierReportLoading = false;
      state.supplierReport = action;
      state.supplierReportError = null;
    },

    generateSupplierReportError: (state, action) => {
      state.supplierReportLoading = false;
      state.supplierReportError = action.payload;
    },

    clearSupplierReport: (state) => {
      state.supplierReport = null;
      state.supplierReportError = null;
    }
  },
  sagas: (A) => ({

    *[A.validerBC]({ payload }) {
      try {
        const { data } = yield call(validerBC, payload.id);
        yield put(A.finishFetching());
        if (payload.onSuccess) {
          yield call(payload.onSuccess);
        }
      } catch (e) {
        console.log(e);
        yield put(A.fetchError());
      }
    },
    *[A.search]({ payload }) {
      try {
        const { data } = yield call(search, payload);
        yield put(A.finishFetching());
        yield put(A.fetchedData(data));
      } catch (e) {
        console.log(e);
        yield put(A.finishFetching());
        yield put(A.fetchError());
      }
    },
    *[A.generateSupplierReport]({ payload }) {
      try {
        const { data } = yield call(generatePurchaseReport, payload.supplierId, payload.dateDebut, payload.dateFin);
        yield put(A.generateSupplierReportSuccess(data));
      } catch (error) {
        yield put(A.generateSupplierReportError(error.message || 'Erreur lors de la génération du rapport'));
      }
    },
    *[A.generateDocument]({ payload }) {
      try {
        const pdfData = yield call(generateDocument, payload.id);
        const blob = new Blob([pdfData], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank'); // Open the PDF in a new window
        yield put(A.generatePdfSuccess());
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },

    *[A.createPurchase]({ payload }) {
      try {

        yield call(createPurchase, payload.data);
        yield put(A.createPurchaseSuccess());

        if (payload.onSuccess) {
          yield call(payload.onSuccess);
        }
      } catch (error) {
        yield put(A.createPurchaseFailure(error.message));
        if (payload.onError) {
          yield call(payload.onError, error);
        }
      }
    },
    *[A.updatePurchase]({ payload }) {
      try {
        const { data } = yield call(updatePurchase, payload.id, payload.data);
        yield put(A.createPurchaseSuccess());
        if (payload.onSuccess) {
          yield call(payload.onSuccess, data);
        }
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getPurchaseData]({ payload }) {
      try {
        const { data } = yield call(getPurchasesData, payload.dateRange);
        yield put(A.getPurchasesDataSuccess(data));
      } catch (error) {
        yield put(A.getPurchasesDataFailure(error.message));
      }
    },

    *[A.getTotalPurchasesToday]() {
      try {
        const { data } = yield call(getTotalPurchasesToday);
        yield put(A.setTotalPurchases(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getTotalPurchasesThisWeek]() {
      try {
        const { data } = yield call(getTotalPurchasesThisWeek);
        yield put(A.setTotalPurchases(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getTotalPurchasesThisMonth]() {
      try {
        const { data } = yield call(getTotalPurchasesThisMonth);
        yield put(A.setTotalPurchases(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getTotalPurchasesThisYear]() {
      try {
        const { data } = yield call(getTotalPurchasesThisYear);
        yield put(A.setTotalPurchases(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },
    *[A.getTotalPurchasesForDateRange]({ payload }) {
      try {
        const { data } = yield call(getTotalPurchasesForDateRange, payload.startDate, payload.endDate);
        yield put(A.setTotalPurchases(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },

    *[A.fetchNewOrderNumber]() {
      try {
        const { data } = yield call(fetchNewOrderNumber);
        yield put(A.setNewOrderNumber(data));
      } catch (error) {
        yield put(A.setError(error.message));
      }
    },

  }),

});

export default purchaseModule;
export const purchaseActions = purchaseModule.actions;